// L'état de lecture vit dans l'adresse (`#vue=leviers&projet=PRJ-007&seuil=0.60`) :
// recharger la page ne perd pas la lecture, les flèches du navigateur ramènent la
// précédente, et un lien se partage. Repris de poc/src/lien.js.

export type CleAdresse =
  "projet" | "vue" | "poids" | "seuil" | "etats" | "tri" | "q" | "arbre" | "filtres" | "placement";

function parametres(hash: string): URLSearchParams {
  return new URLSearchParams(hash.replace(/^#/, ""));
}

export function lireDansAdresse(
  cle: CleAdresse,
  hash: string = window.location.hash,
): string | null {
  return parametres(hash).get(cle);
}

export function ecrireDansAdresse(cle: CleAdresse, valeur: string | null): void {
  const p = parametres(window.location.hash);
  if (valeur) p.set(cle, valeur);
  else p.delete(cle);
  const hash = p.toString();
  const adresse = `${window.location.pathname}${window.location.search}${hash ? `#${hash}` : ""}`;
  window.history.replaceState(null, "", adresse);
}
